export default {
  feedbackAudioIndex: 'Feedback audio {val1}',
  openAudio: 'Open audio',
  history: 'History',
  theImageCannotExceed: 'Image cannot exceed {val1}MB, please re-upload!',
  thereAreTypesOfImagesAvailable:
    'Invalid image type, please upload a correct format!',
  richTextPureText: 'Rich text/plain text toggle',
  richTextContent: 'Rich text content (bold, images, etc.)',
  discard: 'Discard',
  cutFromRichText: 'Switching from rich text to plain text will',
  beCareful: 'Note:',
  numberOfRichTexts: 'Parsing rich text data structure.',
  forTheNumberOfUses:
    'Use a plain text editor for FAQ data; otherwise, you need to',
  switchToPureText:
    'Switching to plain text mode will discard rich text info (images, etc.)',
  reply: 'Reply:',
  articleNbsp: 'Entries:',
  feedback: 'Feedback',
  replyDetails: 'Reply details',
  nbspAnti: ' Feedback',
  batchReplyAs: 'Batch reply successful, replied to ',
  batchSending: 'Batch sending (',
  failInSend: 'Send failed',
  replyPlan: 'Reply plan:',
  open: 'Expand',
  batchSelection: 'Selected batch feedback',
  replyToRecommendedStudents: 'Reply to recommended generated reply plans',
  pleaseInTheLeftColumn: 'Please select feedback on the left list and',
  thereAreCurrentlyNoPlansAvailable: 'No available plans',
  replyAdded: 'Reply plan added (',
  addToReply: 'Add to reply (',
  addedBack: 'Added back to reply',
  adopt: 'Adopt',
  intelligentReplyPush: 'Intelligent reply recommendations',
  automaticFilteringHasBeenImplemented: 'Auto filter replied',
  batchSelected: 'Selected',
  aiRecommendationBack: 'AI recommended reply',
  onlySelectable:
    'Only selectable items with permissions; contact admin for project info.',
  pleaseSelectProject: 'Select a project.',
  changeOfProjectOwnership:
    'Changing ownership clears smart classification, user feedback, and source info.',
  batchChangeOffice: 'Batch change application ownership.',
  networkAbnormalityPlease: 'Network error, try again later.',
  operationSuccessful: 'Operation successful.',
  pleaseSelectProject2: 'Select a project!',
  theImageCannotExceed2: 'Image must not exceed {val1}MB; please re-upload!',
  pleaseSelectTheOriginalFirst: 'Select the original feedback source first.',
  firstLevelClassification: 'First-level classification.',
  pleaseChooseTheOriginalAndReverse: 'Select the original feedback source.',
  originalFeedbackSource: 'Original feedback source.',
  supportFromExistingSources:
    'Select first-level classification from existing sources; copy all data to the target source.',
  pleaseSelectThePurpose: 'Select the purpose feedback source.',
  objectiveFeedback: 'Purpose feedback source.',
  processingInProgress: 'Processing.',
  supportFromExistingSources2:
    'Select first-level classification from existing sources; copy all data to the target source.',
  successCopy: 'Copy successful.',
  sourceFeedbackSource:
    'Source and purpose feedback sources cannot be the same.',
  pleaseSelectTheSource: 'Select source ID.',
  enterMultipleValues: 'Enter multiple values separated by commas.',
  pleaseChooseCustom: 'Please select custom fields',
  editorAndProcessor: 'Editor and processor',
  pleaseEnterTi: 'Please enter {val1}!',
  more: 'More',
  pleaseEnterSearch: 'Please enter search content (press enter to search)',
  uploadingInProgress: 'Uploading...',
  theImageCannotExceed3: 'Image cannot exceed {val1}MB, please re-upload!',
  returnToOtherQuestions: 'Return to other questions',
  sendOut: 'Send',
  pleaseEnterATitle: 'Please enter title for search',
  addTheFaq: 'Reply FAQ content to user',
  setAnalysisDimension: 'Set analysis dimension successfully',
  setAnalysisDimension2: 'Set analysis dimension',
  stopGenerating: 'Stop',
  noHelp: 'No help',
  toBeHelpfulTo: 'Helpful',
  evaluatedHelpless: 'Evaluated: No help',
  reviewedAsHelpful: 'Evaluated: Helpful',
  copy: 'Copy',
  regenerate: 'Regenerate',
  terminationSuccessful: 'Termination successful',
  requestError: 'Request error:',
  helpingMeWrite: 'Helping me write...',
  aiGenerated:
    'AI-generated content is for reference only; you can modify as needed.',
  abandoned: 'Abandoned',
  quote: 'Quote',
  successfullyGenerated: 'Successfully generated',
  connectionInterruption: 'Connection interrupted',
  chooseTheRequiredSystem: 'Choose the system for analysis generation:',
  currentlyNotGenerated: 'No generated log analysis available',
  stopAnalyzing: 'Stop',
  outlierExtraction: 'Outlier extraction',
  summarizeTheTimeline: 'Summarize timeline',
  logAnalysisConclusion: 'Log analysis results',
  analyzeProgress: 'Analysis progress',
  pleaseEnterAsk: 'Enter your question and press Enter to trigger the query.',
  logChatAskTips:
    'You can ask any questions to the model based on log files. The backend will automatically transmit [Feedback Content], [Feedback Time], and filtered [Log Content].\nFor example: Please output logs related to the feedback content.',
  logFile: 'Log file',
  analyzingLogFile: 'Analyzing log file, please wait...',
  pleaseInputKeyWords: 'keyword search requires ',
  pleaseSelectFirst: 'Non global search requires selecting a file first',
  confirm: 'Confirm',
  time: 'Time',
  loadingInProgress: 'Loading',
  logAnalysisCompleted: '---- Log analysis completed',
  logAnalysisAccuracy: '---- Log analysis preparing, please wait',
  logAnalyzeTabForAnalysis: 'analysis',
  logAnalyzeTabAnalysis: 'Log analysis',
  logAnalyzeTabForAsk: 'ask me',
  logAnalyzeTabHistory: 'history',
  problemAnalysisSmall: 'Analysis summary',
  aggus: '{val1} people',
  aggco: '{val1} entries',
  relatedFeedbackSummary: '{val1} related feedback entries',
  feedbackTitlesOmitted: '{val1} additional feedback titles are not shown',
  value: '{val1} feedback users proportion: {val2}',
  value2: '{val1} feedback users: {val2}',
  value3: '{val1} feedback volume proportion: {val2}',
  feedbackQuantityAg: 'Feedback volume: {val1}',
  unknownState: 'Unknown state',
  waitingForReply: 'Awaiting reply',
  setUpAListExhibition: 'Set up list display fields and sorting',
  nothing: 'None',
  sourceLink: 'Source link:',
  feedbackClassificationN: 'Intel classification: ',
  feedbackUserLetter: 'Feedback user info',
  state: 'State',
  totalTota: 'Total: {val1} entries',
  creationTime: 'Creation time',
  oncal: 'Oncall ticket',
  transferred: 'Transferred',
  transferredToOnc: 'Transferred to Oncall ticket',
  transferredToTap: 'Transferred to TAPD',
  stay: 'Pending',
  already: 'Already',
  unrecognized: 'Unrecognized',
  toBeFollowedUpOn: 'To be followed up',
  unknown: 'Unknown',
  viewAll: 'View all',
  recentlyUsersHaveBeenAgainst: 'Recent user feedback (',
  pleaseEnterFloatingPoint: 'Please enter a floating point number',
  pleaseEnterPlasticSurgery: 'Please enter a surgery number',
  theNumberOfWordsInTheRemarksIsNot: 'Remarks must not exceed 400 characters',
  changeFailed: 'Change failed',
  changeSuccessful: 'Change successful',
  processingPersonnel: 'Processing personnel',
  errorInType: 'Type error',
  jumpLink: 'Jump link',
  pleaseEnterTheField: 'Please enter field name for search',
  addFilter: 'Add filter',
  advanceFilter: 'Advanced filter',
  exportOption: 'Export options',
  pleaseChooseWhetherOrNot: 'Please select whether empty',
  pleaseEnter: 'Please enter',
  forEmpty: 'Empty',
  notEmpty: 'Not empty',
  contain: 'Contains',
  equals: 'Equals',
  selectedFieldsTo: 'Selected fields and sorting (',
  noFieldsAvailableAtTheMoment: 'No fields available at the moment',
  searchFields: 'Search fields',
  exportFieldSelection: 'Export field selection (up to 100,000 entries)',
  exportAsWecomDocument: 'Export as WeChat Work Document',
  advancedQuery: 'Advanced query',
  exportSuccessful: 'Export successful!',
  exportWecomSuccessful: 'Export successful! Please check the push from WeChat Work [AiSee Bot].',
  exportFailedPlease: 'Export failed, please try again later',
  weAreGuidingYou: 'Exporting for you, please wait...',
  feedbackDetails: 'Feedback details',
  imageContent: 'Image content',
  picturesLinking: 'Image links',
  pleaseChoose: 'Please select',
  setListDisplay: 'Set list display fields',
  aField: 'Field',
  nbHasBeenSelected: 'Selected: ',
  usedForAnalyzingACertain:
    'Used for analyzing certain parameters (including custom fields) value distribution or month-on-month change; effective after viewing in [Feedback Parameter Statistics]',
  userAccount: 'User account',
  noRelevantIntelligenceAvailableAtTheMoment:
    'No relevant intelligent classification available!',
  searchIntelligenceScore: 'Search intelligent classification',
  selectedCategoryT: 'Selected category: {val1}',
  feedbackClassification: 'Intel classification',
  processingStatus: 'Processing status',
  feedbackInfo: 'Feedback Info',
  pleaseEnterTheType: 'Please enter type name for search',
  pleaseChooseIntelligent: 'Please select intelligent classification',
  userSelectedScore: 'User-selected classification',
  pleaseChooseACategory: 'Please select a category',
  pleaseEnterTheField2: 'Please enter field value',
  multipleUsagePoints: 'Multiple uses, separated',
  pleaseChooseARating: 'Please select rating option',
  pleaseSelectAQuestionnaire: 'Please select a questionnaire',
  allCategories: 'All',
  versionFeedbackVolume: 'Version feedback volume',
  value4: '{val1} people',
  value5: '{val1} entries',
  feedbackTypeN:
    'Feedback type: {val1}<br/> Feedback volume: {val2}<br/> Proportion: {val3}',
  feedbackTypeN2: 'Feedback type: {val1}<br/> Proportion: {val2}%',
  feedbackQuantity: 'Feedback quantity',
  statisticalDimension: 'Statistical dimension:',
  monthly: 'Mo.',
  byWeek: 'We.',
  onADailyBasis: 'Da.',
  statisticalMethod: 'Statistical method:',
  notSelectedAtAll: 'None selected',
  selectAll: 'Select all',
  value6: '{value} people',
  value7: '{value} entries',
  fileT: '{val1} trend statistics.xlsx',
  intelligentClassificationTrend: 'Intelligent classification trend.xlsx',
  exportExc: 'Export Excel',
  close: 'Close',
  dataView: 'Data view',
  intelligentClassificationTrend2: 'Intelligent classification trend chart',
  viewTrends: 'View trends',
  trend: 'Trend',
  numberOfFeedbackUsers: 'User feedback count month-on-month',
  feedbackFromThePreviousCycle: 'Previous cycle feedback user count',
  feedbackOnUserProportion: 'User Proportion',
  numberOfFeedbackUsers2: 'Feedback user count',
  feedbackOnAMonthOnMonthBasis: 'Feedback count month-on-month',
  feedbackFromThePreviousCycle2: 'Previous cycle feedback count',
  previousWeek: '(Previous week)',
  nowWeek: '(This week)',
  feedbackQuantity2: 'Feedback count',
  thePicturesAndVideosHaveBeen: 'Images/videos are corrupted',
  addPicturesAndVideos: 'Loading images/videos...',
  imagePreview: 'Image preview',
  videoPreview: 'Video preview',
  nbspIntelligence: ' Intelligent classification trend chart',
  pleaseInputAnImage: 'Please enter image link',
  multilingual: 'Multilingual',
  optionLabelName: '(Option/Label) Name',
  pleaseClickOnMultilingual:
    'Please click the multilingual button to enter name',
  modifyOptionLabel:
    'Modifying (Option/Label) will affect all questionnaires using this (Option/Label), please proceed with caution',
  modifiedSuccessfully: 'Modified successfully',
  pleaseEnterAName: 'Please enter a name or image link',
  typel: '{val1} name',
  pleaseEnterAName2: 'Please enter a name',
  serverException: 'Server exception, please try again later',
  title: '{val1} - Multilingual',
  spanish: 'Spanish',
  portuguese: 'Portuguese',
  arabic: 'Arabic',
  korean: 'Korean',
  japanese: 'Japanese',
  malayLanguage: 'Malay',
  hindiLanguage: 'Hindi',
  indonesia: 'Indonesian',
  vietnamese: 'Vietnamese',
  thai: 'Thai',
  traditionalChinese: 'Traditional Chinese',
  pleaseEnterSimplifiedChinese: 'Please enter simplified Chinese',
  simplifiedChinese: 'Simplified Chinese',
  pleaseEnterEnglish: 'Please enter English content',
  englishFallback: 'English (fallback)',
  uploadLogsSeparately: 'Upload log analysis',
  journal: 'Log',
  recordingFrequency: 'Recording frequency',
  experimentalData: 'Experimental data',
  switch: 'Switch',
  sdkLogs: 'SDK logs',
  chooseJapaneseChronicle: 'Select log file',
  pleaseSelectALog: '// Please select a log file',
  selectTime: 'Select time',
  selectDate: 'Select date',
  onlyLeavesCanBeSelected: 'Only leaf nodes can be selected',
  feedbackClassificationSelection: 'Intel classification selection',
  pleaseEnterToReply:
    'Please enter reply content,(press Enter to send, Ctrl+Enter for new line)',
  messageRecallNotice:
    'Messages can be withdrawn within 7 days after sending (only by administrators or the sender themselves)',
  viewDetails: 'View details >',
  comingSoon: 'Coming soon',
  feedbackFailed: 'Feedback failed',
  feedbackSuccessful: 'Feedback successful',
  resultsOfEnforcement: 'Results of enforcement',
  tipsLimit:
    'Tips: Limit feedback trigger count per second, max 500 feedbacks per second',
  frequencyLimit: 'Frequency limit',
  pleaseSelectAPlugin: 'Please select a plugin',
  implement: 'Implement',
  batchTriggerInsertion: 'Batch trigger plugin',
  pluginExecutionLost: 'Plugin execution failed: {val1}',
  see: 'See',
  open2: 'Open',
  transferredToOnc2: 'Transferred to Oncall',
  addToQuestion: 'Add to question',
  feedbackFollowUpOperation: 'Feedback follow-up operation successful',
  enterEnterpriseMicro:
    'Enter enterprise WeChat English name, separated by semicolon',
  pleaseCheckAr: 'Please check if {val1} name is correct',
  currentlySelected: 'Currently selected product:',
  pleaseSelectAProduct: 'Please select a product',
  project: 'Pro',
  pleaseEnterTheProduct: 'Please enter product keyword',
  invalidIssue: 'Invalid issue',
  confirmedIssue: 'Confirmed issue',
  notConfirmed: 'Not confirmed',
  pleaseChooseToModify: 'Please select modification status',
  pleaseInputProcessing: 'Please enter processor',
  noteMultipleTreatments:
    'Note: Multiple processors separated by English semicolon',
  pleaseInputProcessing2: 'Please enter processor!',
  pleaseEnterTheQuestion: 'Please enter issue description',
  describe: 'Description',
  pleaseEnterADescription: 'Please enter description!',
  pleaseEnterTheQuestion2: 'Please enter issue title',
  pleaseEnterATitle2: 'Please enter title!',
  editingIssues: 'Editing issues',
  modifyTheProblemToBeLost: 'Failed to modify issue, please try again later',
  modifyTheProblemTo: 'Issue modified successfully',
  multipleProcessors: 'Multiple processors separated by English semicolon',
  synchronizeUpdates: 'Synchronize updates',
  questionTitle: 'Issue title',
  problemLevel: 'Issue level',
  addToExisting: 'Add to existing issue',
  addToTAPD: 'Add to existing TAPD',
  newProblem: 'New issue',
  articleFeedback: 'Entries of feedback',
  articleFeedbackData: 'Entries of data',
  selected: 'Selected',
  afterAddressingTheIssueItCanBeResolved:
    'After addressing, view in [Issue Follow-up] and transfer if added.',
  pleaseClarifyTheMeaningOfTheSentence:
    'Categorize consistent feedback as issues for follow-up in [Issue Follow-up].',
  thisProjectDoesNotHave: 'This project is not bound to TAPD!',
  followUpOnTransferringIssues: 'Transfer issue follow-up',
  followUpOnTransferringIssuesTips: 'Further batch transfer to tapd and oncall processing',
  bindTap: 'Binding TAPD successful',
  bindTap2: 'Binding TAPD failed: err: {val1}',
  relatedIssuesLost: 'Failed to associate issue',
  relatedIssuesBecome: 'Successfully associated issue',
  relatedIssuesLost2:
    'Failed to associate issue, please try again later: {val1}',
  issueBindSuccessButTapdBindFailed: 'Issue associated successfully, but TAPD binding failed',
  issueBindSuccessButTapdBindFailedWithError: 'Issue associated successfully, but TAPD binding failed: {val1}',
  issueCreatedButTapdBindFailed: 'Issue created successfully, but TAPD binding failed: {val1}',
  issueBindSuccessButNoTapdInfo: 'Issue associated successfully, but no existing TAPD info found',
  createIssueAndBindTapdSuccess: 'Issue created and TAPD bound successfully',
  createIssueFailed: 'Failed to create issue',
  createIssueFailedWithError: 'Failed to create issue: {val1}',
  operationFailed: 'Operation failed: {val1}',
  addToIssueAndBindTapd: 'Add to issue and bind TAPD',
  pleaseEnterTapdId: 'Please enter TAPD ID',
  pleaseSelectIssue: 'Please select issue',
  foundRelatedIssue: 'Related issue found~',
  selectIssue: 'Select issue',
  pleaseSelectIssueToBind: 'Please select issue to bind',
  noRelatedIssueFoundWillCreateNew: 'No related issue found, will create new issue',
  pleaseSelectWorkspace: 'Please select workspace',
  dataContentSyncUpdate: 'Data content sync update',
  moreFields: 'More fields',
  getWorkspaceListFailed: 'Failed to get workspace list',
  addAsProblem: 'Add as issue',
  addAsProblemAndCopy: 'Add as issue and copy',
  transferProblemAndCopy: 'transfer as issue and copy',
  addAndConvertToO: 'Add & Oncall',
  addAndConvertToT: 'Add & TAPD',
  theTitleCannotBe: 'Title cannot be empty',
  theHandlerCannot: 'Processor cannot be empty',
  withdrawalMessageLost:
    'Withdraw message failed, please refresh the page and try again!',
  withdrawTheMessage: 'Withdraw message successful!',
  replySuccessful: 'Reply successful',
  turn: 'Transfer',
  batchManualReturn: 'Batch manual reply',
  reply2: 'Reply',
  pleaseSelectAtLeast: 'Please select at least one record',
  userInitiated: 'User rating initiated, awaiting user response',
  thisServices: 'Satisfaction of this human service',
  unknownUser: 'Unknown user',
  withdraw: 'Withdraw',
  continue: 'Continue',
  whetherToWithdrawI:
    'Withdraw: 【{val1}】, user will not see this reply after withdrawal',
  withdrawMessage: 'Withdraw message',
  confirmThisFeedback:
    'Confirm this feedback has been processed and initiate user rating?',
  initiateSatisfaction: 'Initiate satisfaction rating',
  alreadyInitiated:
    'Rating has already been initiated, please check user rating results!',
  userInitiated2: 'User rating initiated, awaiting user response!',
  quickReply: 'Quick reply',
  originalFeedbackReply: 'Original feedback reply details',
  noViewOriginal: 'No permission to view original',
  aiSee: 'AiSee recommends these reply options:',
  uploadFailedPlease: 'Upload failed, please try again later',
  uploadImage: 'Upload image',
  pleaseEnterAReply: 'Please enter reply content or upload an image',
  pictureUploadingInProgress: 'Image uploading...',
  pleaseEnterCo:
    'Please enter {val1}, separate multiple values with commas or spaces',
  pleaseSelectProcessing: 'Please select processing status',
  multipleOnCs:
    "Multiple oncall assignees separated by semicolon ';', priority given to the assignees listed here (if empty, assign to oncall platform's configured personnel)",
  oncal2: 'Oncall assignees',
  configurationMethod: 'Configuration method',
  pleasePrepareInAdvanceInO:
    'Please configure the corresponding rules in the oncall platform in advance; otherwise, the ticket creation will fail.',
  oncal3: 'Oncall business category',
  oncal4: 'Oncall operational product',
  newOnc: 'Create new ONCALL ticket',
  oncal5: 'Oncall transfer failed, please re-enter',
  noOperationalAuthority:
    'No operational authority, please apply for permission before proceeding.',
  oncal6: 'Oncall transfer failed, please retry the transfer',
  oncal7: 'Oncall transfer successful',
  sReco: '{val1} feedback pending',
  pleaseChooseOn: 'Please select oncall operational product',
  proposal: 'Suggestion',
  tips: 'Tips',
  commonly: 'Common',
  serious: 'Serious',
  deadly: 'Critical',
  empty: '--Empty--',
  beOfNoGreatImportance: 'Minor importance',
  low: 'Low',
  in: 'Medium',
  high: 'High',
  urgent: 'Urgent',
  newToTa: 'Create transfer to Tapd',
  addComments: 'Add comments',
  pleaseChooseOne: 'Please select a handler',
  configureOtherT: 'Configure other Tapd projects',
  convertToTapd:
    'Transfer to Tapd encountered an exception, please check the transfer results in the Tapd space!',
  convertToTapd2: 'Transfer to Tapd demand ticket successful!',
  convertToTapd3: 'Transfer to Tapd defect ticket successful!',
  demand: 'Demand',
  waitingForTheFeed: 'Waiting for {val1} feedback',
  pleaseSelectProcessing2: 'Please select handler',
  pleaseChooseATitle: 'Please select a title',
  pleaseSelectType: 'Please select a type',
  pleaseSelectNew: 'Please select the new Tapd space to create in',
  viewDetails2: 'View details',
  managementBackendCheck: '>>> Check issue details in the management backend: ',
  divst:
    '<div style="display: flex">Terminal log: <div style="display: inline-block">{val1}</div></div>',
  ahref: '<a href="{val1}" style="cursor: pointer;">Log info {val2}</a><br/>',
  isItRoo: 'Is it Root: No',
  isItRoo2: 'Is it Root: Yes',
  networkFee: 'Network: {val1} <br/><br/>',
  modelFee: 'Model: {val1} <br/><br/>',
  manufacturerFee: 'Manufacturer: {val1} <br/><br/>',
  systemVersionF: 'System version: {val1} <br/><br/>',
  regionalFee: 'Region: {val1} <br/><br/>',
  feedbackTimeF: 'Feedback time: {val1}<br/><br/>',
  discoveredVersionF: 'Discovered version: {val1}<br/><br/>',
  accountFee: 'Account: {val1}<br/><br/>',
  defect: 'Defect',
  pleaseEnterTa: 'Please enter the long ID from the TAPD link',
  pleaseEnterTa2: 'Please enter the long ID from the TAPD link!',
  defectId: 'Defect ID',
  requirementId: 'Requirement ID',
  pleaseSelectType2: 'Please select a type!',
  type: 'Type',
  relatedTo: 'Related to',
  convertToTapd4:
    'Transfer to Tapd encountered an exception, please retry or contact the administrator!',
  convertToTapd5: 'Transfer to Tapd issue ticket successful!',
  waitingForTheFeed2: 'Waiting for {val1} feedback',
  associateTap: 'Associate Tapd ticket',
  pleaseEnterMa: 'Please enter {val1}!',
  waitingForTheFeed3: 'Waiting for {val1} feedback',
  timeIsTheMost: '[{val1} Latest summary of {total_count_to_replace} feedback]',
  divst2:
    '<div style="display: flex">Backend log: <div style="display: inline-block">{val1}</div></div><br/>',
  divst3:
    '<div style="display: flex">Terminal log: <div style="display: inline-block">{val1}</div></div>',
  ahref2: '<a href="{val1}" style="cursor: pointer;">Log info {val2}</a><br/>',
  imgal2:
    '<img alt="image.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  networkFee2: 'Network: {val1} <br/><br/>',
  modelFee2: 'Model: {val1} <br/><br/>',
  manufacturerFee2: 'Manufacturer: {val1} <br/><br/>',
  systemVersionF2: 'System version: {val1} <br/><br/>',
  regionalFee2: 'Region: {val1} <br/><br/>',
  feedbackTimeF2: 'Feedback time: {val1}<br/><br/>',
  discoveredVersionF2: 'Discovered version: {val1}<br/><br/>',
  accountFee2: 'Account: {val1}<br/><br/>',
  fixedUnfolding: 'toFixed',
  automaticContraction: 'Auto Collapse',
  navigationDisplay: 'Nav. Mode',
  chinese: 'Chinese',
  switchLanguage: 'Switch language',
  productPermissionApplication:
    '[Product Permission Application] Message reminder settings',
  messageReceptionConfiguration: 'Message reception configuration',
  updateFailed: 'Update failed!',
  updateSuccessful: 'Update successful!',
  enterpriseWeChat: 'Enterprise WeChat email',
  logOutAndLogIn: 'Log out',
  messageConfiguration: 'Message configuration',
  permissionReview: 'Permission review',
  feedbackOnOpinions: 'Feedback on opinions',
  copyId: 'Copy ID',
  second: 'Times',
  feedbackInThePastThreeDays: 'Feedback in the past three days',
  inThePastYearThe: 'In the past year',
  currentFeedback: 'Current feedback',
  goToTheFeedbackList: 'Go to feedback list',
  accumulatedInThePastYear:
    'Accumulated feedback in the past year: {val1} times',
  accumulatedReversalsThisMonth: 'Accumulated feedback this month ',
  forTheFirstFeedback: 'First-time feedback user',
  theLastTimeOn: 'Last seen on',
  copyUserAccount: 'Copy user account',
  accordingToTheCurrentTime: 'Move back according to current time',
  whole: 'Whole',
  allFeedbackVersion: 'All feedback versions',
  edition: 'Edition',
  allSources: 'All sources',
  allFeedbackCategories: 'All types of feedback',
  switchList: 'Switch',
  rankingList: 'Ranking',
  htmlSource: 'HTML Source Mode',
  visualizationMode: 'Visualization Mode',
  pleaseEnterTheApplication: 'Please enter the application reason',
  reasonForApplication: 'Application Reason:',
  pleaseSelectOnTheLeftSide:
    'Please select the product on the left that requires permission',
  selectedApplication: 'Selected application',
  firstLevelApplicationName: 'First-Level Application Name',
  pleaseSelectAnApp: 'Please select an application',
  afterApplicationManagementIsRequired:
    'After application, administrator approval is required to access the corresponding application.',
  applyingToJoinShould: 'Apply to Join Application',
  thirdLevelProductName: 'Third-Level Product Name',
  secondaryProductName: 'Secondary Product Name',
  applicationFailed: 'Application failed: ',
  applicationSuccessful: 'Application successful',
  pleaseChooseToApply: 'Please select the role to apply for',
  pleaseFillInTheApplicationForm: 'Please fill in the application reason',
  pleaseChooseToApply2: 'Please select the product to apply for',
  aiSee2: 'AiSee Assistant',
  conversionTypeProduct: 'Convert to Formal Product',
  viewProductConnection: 'View Product Integration Guide',
  ifYouHaveAnyQuestionsPlease: 'Contact AiSee Assistant for questions',
  inAutomaticClassification: 'Classifying',
  enterTheExperience: 'Enter Experience',
  automaticallyCreated: 'Auto-created',
  importedHistory:
    'Imported data will be auto-classified (trial products only)',
  addAfterActivation:
    'New feedback will be auto-classified via AI model after activation',
  areYouSureToEnableIt: 'Enable this model?',
  step4Report: 'Step 4: Report Generation',
  step3Results: 'Step 3: Result Verification',
  step2Model: 'Step 2: Model Training',
  step1Data: 'Step 1: Data Preparation',
  convertToFormalProduction: 'Convert to Formal Product',
  ohMyGodYouCanCommunicate:
    'days remaining. Experience insights with sample data. Convert to formal product to integrate AiSee.',
  remainingExperiencePeriod: 'Remaining Days',
  inDoubt: 'Questions?',
  recommendedExperience: 'Core Features',
  trialGuide: 'Trial Guide',
  intelligentMonitoringSystem:
    'Intelligent Monitoring: Real-time feedback tracking with custom conditions and threshold alerts, auto-push WeChat notifications for high-frequency issues',
  viewExamples: 'View Examples',
  setAlarmRules: 'Set Alert Rules',
  intelligentClassificationRoot:
    'Intelligent Classification: Auto-classify based on feedback data with manual calibration, real-time trend dashboard',
  intelligentClassification: 'Intelligent Classification',
  viewOrModify: 'View/Modify Classification',
  setClassificationTree: 'Set Classification Tree',
  preciseSubscriptionPre:
    'Precise Subscription: Multi-dimensional conditions (tags + keywords + multi-person push) trigger WeChat notifications instantly',
  selectScenarioOne: 'One-Click Subscribe',
  globalClosedLoopEmbedding:
    'Full-Cycle Integration: Embed AiSee H5 for consultation-query-submit-follow-up workflow',
  feedbackPageHConnected: 'Feedback Page H5 Integration',
  fillInFeedbackAndSubmit: 'Fill in Feedback and Submit',
  userClassificationConfiguration: 'User Classification Configuration',
  faqSettings: 'FAQ Settings',
  smartReply: 'Smart Reply',
  aiReplyPush: 'AI Reply Recommendation Reference',
  pollingClassificationStatus: 'Polling classification status failed:',
  checkModelStorage: 'Error checking model existence:',
  modelGenerationSuper: 'Model generation timeout',
  updateStepsLost: 'Update step failed, please contact assistant',
  iSee: 'I understand',
  activateImmediately: 'Activate Immediately',
  basedOnImports:
    'AiSee auto-generated a classification tree from imported data.\n          New feedback will be auto-classified after activation',
  feedbackClassificationTree: 'Classification Tree Created',
  automaticClassificationAndExtraction: 'Auto-Classification Notice',
  visitAiS:
    'Access AiSee public demo with sample data to experience core features',
  experiencePublicD: 'Public Demo',
  aiSee3: 'AiSee creates a trial product. Import ≤500 entries to test features',
  experienceExclusiveProducts: 'Trial Product',
  each: 'Each',
  relationship: 'Relationship',
  faqReply: 'FAQ Reply',
  updateTime: 'Update Time:',
  creator: 'Creator:',
  prompt: 'Prompt:',
  mcpse: 'MCP Server Link',
  ordinaryApi: 'Regular API',
  toolType: 'Tool Type:',
  toolLink: 'Tool Link:',
  confirmDeletion: 'Confirm Deletion',
  confirmDeletion2:
    'Are you sure you want to delete agent "{val1}"? This cannot be undone.',
  agent: 'Agent',
  whenCallingALink:
    'Headers to pass when calling the link, in the form {"key": "value"}',
  toolHea: 'Tool Header',
  toolLinkH:
    'Tool link header format is incorrect, please enter a valid JSON format',
  ordinaryApi2: '1. Regular API, 2. MCP server link',
  toolLinkClass: 'Tool Link Type',
  useToolchain: 'Tool link type cannot be empty when using tool links',
  youCanSpecifyOne:
    'You can specify a link, either a regular API or MCP server link',
  toolLink2: 'Tool Link',
  toolConfiguration: 'Tool Configuration',
  doYouWantIntelligence: 'How do you want the agent to analyze problems',
  promp: 'Prompt cannot be empty',
  theNameOfTheIntelligentAgent: 'The name of the agent',
  intelligentAgentName: 'Agent Name',
  intelligentAgentName2: 'Agent name cannot be empty',
  saving: 'Saving...',
  save: 'Save',
  addIntelligentAgent: 'Add Agent',
  editIntelligentAgent: 'Edit Agent',
  pleaseChooseFirst: 'Please select an application first',
  updateFailed2: 'Update failed',
  inEditingMode: 'Missing agent information in edit mode',
  thereAreCurrentlyNoIntelligentAgentsAvailable:
    'No agents available, you can add one',
  noMatchFound: 'No matching agent found',
  searching: 'Searching...',
  configurationGuidelines: 'Configuration Guide',
  pleaseInputIntelligence: 'Please enter agent name',
  customizedAnalyticsIntelligence: 'Custom Analytics Agent',
  deleteIntelligentAgent: 'Failed to delete agent:',
  deleteFailedMissing: 'Delete failed: Missing required parameters',
  obtainIntelligentAgents: 'Failed to get agent list:',
  expandTheFullText: 'Expand Full Text',
  oneClickAnalysis: 'One-Click Analysis',
  hidden: 'Hidden',
  pleaseClickTheButton: 'Please click the button to upload log file',
  fileUploadLost: 'File upload failed',
  pleaseSelectAScene: 'Please select a scene',
  editScene: 'Edit Scene',
  youCanDefine:
    'Define scenes with feature words for focused filtering and improved analysis readability',
  referenceSceneClassification: 'Scene Analysis',
  analyzeLogStorage: 'Log analysis error, contact assistant',
  thereAreDifferencesInTheProcess: 'Process error, contact assistant',
  taskCreationLost: 'Task creation failed',
  noSelectionMade:
    'No files selected. Use "Global Search" to filter all files before analysis',
  enterTheQuestionBack: 'Enter question, press Enter/click Send',
  analysisErrorM: 'Analysis error: {val1}',
  analysisCompleted: 'Analysis completed',
  noSelected: 'No files selected, will analyze all files',
  feedbackTimeD: 'Feedback Time: {val1}',
  feedbackContentD: 'Feedback Content: {val1}',
  rDLead: 'R&D Lead',
  fixedVersion: 'Fixed Version',
  discoveryVersion: 'Discovery Version',
  problemDescription: 'Problem Description',
  explanationOfDefinition: 'Definition Explanation',
  featureWords: 'Feature Words',
  pleaseEnterRD: 'Please enter R&D lead',
  pleaseEnterRepair: 'Please enter fixed version',
  pleaseEnterTheDiscovery: 'Please enter discovery version',
  pleaseEnterChinese: 'Please enter Chinese definition',
  pleaseEnterTheFeatures: 'Please enter feature words',
  setFeatureWords: 'Set Feature Words',
  pleaseEnterTheScene: 'Please enter scene name',
  youCanDefine2:
    'Define scenes (e.g., login anomaly) with feature words for focused filtering. AiSee outputs conclusions based on definitions for better readability',
  addLogSection: 'Add Scene',
  editLogSection: 'Edit Scene',
  error: 'Error',
  theSceneNameHasBeenChanged: 'Scene name exists',
  logAnalysisField: 'Log Analysis Scene',
  thereAreCurrentlyNoScenesAvailable: 'No scenes',
  noMatchFound2: 'No matching scene',
  addScene: 'Add Scene',
  afterOpeningItWillStartFrom:
    'Global search scans all files and ignores time filters',
  globalSearch: 'Global Search',
  inputToExclude: 'Enter keywords to exclude, press Enter to submit',
  defaultUseIsPositive: 'Use regular expression search by default',
  excludeKeywords: 'Exclude Keywords',
  usageScenarioConfiguration: 'Search using keywords from scene configuration',
  selectScene: 'Select Scene',
  enterToSearch: 'Enter keywords to search, press Enter to submit',
  supportTheUseOfPositive:
    'Supports regular expressions. When using regex search, wrap content with /, e.g., /ab+c/',
  searchKeywords: 'Search Keywords',
  globalSearchMeeting: 'Global search scans all files and ignores time filters',
  globalSearchPlease: 'Specify search or exclude keywords for global search',
  smallBeforeAndAfterFeedback: '±1 hour',
  feedbackBeforeAndAfter: '±30 minutes',
  feedbackBeforeAndAfter2: '±10 minutes',
  hoursBeforeFeedback: '1 hour before',
  minutesBeforeFeedback: '30 minutes before',
  minutesBeforeFeedback2: '10 minutes before',
  viewBestPractice: 'View Best Practices',
  problemSolvingPleaseDont:
    'DeepSeek helps troubleshoot. Click "One-Click Analysis" for suggestions',
  notYetFull: 'Need more analysis?',
  viewTheCompleteContent: 'View Complete Content',
  inTheCurrentSummary:
    '(Current summary content is too long, displayed in collapsed form)',
  thoughtProcess: 'Thought Process',
  pushTime: 'Push Time',
  pleaseEnterAMessage: 'Please enter message title',
  messageTitle: 'Message Title',
  projectName: 'Project Name',
  pleaseEnterTheGroupMachine: "Please enter the group bot's webhook address",
  pushToGroup: 'Push to Group',
  pleaseSelectNotification: 'Please select notification group',
  referenceNotificationGroup: 'Reference Notification Group',
  manuallyAdd: 'Manually Add',
  pleaseChooseToReceive: 'Please select receiving method',
  pushToIndividuals: 'Push to Individuals',
  subscriptionMethod: 'Subscription Method',
  subscriptionNameConvenience:
    'Subscription name for easy query in subscription list',
  subscriptionName: 'Subscription Name',
  multiPersonSubscription: 'Multi-Person Subscription',
  allRankings: 'All Rankings',
  pushRankings: 'Push Rankings',
  enterpriseWeChat2: 'Display remark content at the end of WeChat messages',
  subscriptionSuccessfullyReceived:
    'Subscribed. New feedback will be pushed to WeChat within 5 minutes',
  inTheSameScene:
    'Add multiple conditions (e.g., different classifications) in the same scene to trigger separate pushes',
  addPushFrequency: 'Add Frequency',
  classifyTheSystem: 'Push classification statistics',
  intelligentClassification2: 'Classification Analysis Summary Push',
  expandSubClass: 'Expand Sub-class',
  expandSubClassTip: 'Show child categories of the selected classification',
  subscribe: 'Subscribe',
  advancedSettings: 'Advanced Settings',
  useOfFiltering: 'Scheduled push of filtered feedback',
  selectedUserFeedback: 'Selected Feedback Push',
  addNewQuestions: 'Push notifications for new issues (you as handler)',
  newQuestionPush: 'New Issue Push',
  putUnderYourName: 'Scheduled push of your issue status',
  problemFollower: 'Issue Follower Push',
  thereWillBeComplianceWithTheRegulations:
    'Push new feedback matching conditions',
  addUserReverse: 'New Feedback Push',
  selectedAtACertainTime: 'TOP user voices in time period',
  userVoiceSubscription: 'User Voice Push',
  userVoicePush: 'User Voice Push',
  sessionClassification: 'Session Classification',
  withinTheAiSession: 'AI Session Content',
  upvoteDownvote: 'Upvote/Downvote',
  customerReviews: 'User Reviews',
  satisfactionScore: 'Satisfaction Score',
  unfinished: 'Unfinished',
  ended: 'Ended',
  hasItEnded: 'Has it ended',
  replyStatus: 'AI Reply Status',
  conversationType: 'Conversation Type',
  conversationUserMessage: 'Conversation User Info',
  whenSubmittingAConversation: 'Conversation Submission Time',
  aiConversationStatus: 'AI Session Status',
  recor: '{val1} min',
  feedbackProcessingRecord: 'Feedback Processing Record',
  notTheCurrentProduct:
    'Feedback from non-current products does not support jump',
  onlineAnalysis: 'Online Analysis',
  doYouWantToContinueGuiding: 'Do you want to continue exporting?',
  theArticleMayLeadTo:
    'entries, may take a long time to export, suggest exporting in segments.',
  currentExportQuantity: 'Current export data volume is large',
  continueExporting: 'Continue Exporting',
  exportConfirmation: 'Export Confirmation',
  conversationContent: 'Conversation Content',
  userVoiceMaster: 'User Voice Topic',
  tapdChain: 'TAPD Link',
  doYouWantToHideTheOperation: 'Do you want to hide the operation bar',
  pleaseSelectAtLeast2: 'Please select at least one person!',
  searchForUserLost: 'Search user failed:',
  customField: 'Custom Field Trend Chart',
  tdsty: '<td style="padding: 0 10px; width: 180px">Feedback Name</td>',
  ifTheVideoIsNot:
    'If the video cannot play normally, please click the download video button above to play locally.',
  downloadVideo: 'Download Video',
  downloadFailedPlease:
    'Download failed. Contact AiSee assistant. Error: {val1}',
  pleaseInputTheFile: 'Enter file name',
  fileName: 'File Name',
  viewHistoricalDocuments: 'View History',
  conductAnalysis: 'Analyze',
  uploadLocalText: 'Upload File',
  theAnalysisResultsAreNotAccurate: 'Unsatisfied? {val1}',
  fileLoadingInProgress: 'Loading...',
  uploader: 'Uploader',
  uploadTime: 'Upload Time',
  correspondingUploaded: 'Original file, archive, or single log',
  onlineViewingDay: 'View Logs',
  viewLogsAnd: 'View Logs & Analysis',
  openLogDetails: 'Failed to open log details',
  uploadFileLost: 'Upload failed:',
  fileUploadLost2: 'Upload failed: URL or fid missing',
  openLogDetails2: 'Failed to open log details:',
  retrieveLogU: 'Failed to retrieve log URL',
  retrieveLogU2: 'Failed to retrieve log URL',
  endTime: 'End Time',
  startTime: 'Start Time',
  pleaseSelectALanguage: 'Please select language',
  cannotExceedL: 'Cannot exceed {val1} languages',
  canAddLAgain: 'Can add {val1} more other languages',
  alreadySetE: 'Already set {val1} other languages',
  english: 'English',
  traditionalChineseChannel: 'Traditional Chinese (Taiwan)',
  simplifiedChinese2: 'Simplified Chinese (Mainland China)',
  jumpToFollowUp: 'Jump to Follow-up',
  submit: 'Submit',
  conversionTypeProduct2:
    'Converting to formal product retains history (classification, FAQ, etc.)',
  clickToUploadImage: 'Upload Image',
  imageResolution: '(120×120)',
  productImage: 'Product Image',
  pleaseEnterTheProduct2: 'Enter product description',
  productDescription: 'Product Description',
  productDescriptionIsNotProvided: 'Max 150 characters',
  pleaseEnterTheProduct3: 'Enter product name',
  productName: 'Product Name',
  productNameOnly:
    'Chinese, letters, numbers, underscores, spaces, hyphens only',
  theProductNameIsNot: 'Max 20 characters',
  goToObs: 'View in OBS',
  belongingOperationalProduct:
    'Operational Product',
  contactAiS1: 'If you can\'t find the corresponding product, please contact',
  AiSeeAssistant: '\u00A0Aisee Assistant',
  contactAiS2: '\u00A0to add it',
  pleaseChooseInO: 'Select operational product in OBS',
  pleaseSelectYourAffiliation: 'Select operational product',
  unableToFindProduct: 'Product not found. Contact admin',
  theImageSizeIsIncorrect: 'Image size cannot exceed 5MB!',
  onlyJCanBeUploaded: 'Only JPG/PNG format images can be uploaded!',
  problemClassification: 'Problem Classification',
  followerRole: 'Follower Role',
  questionType: 'Question Type',
  pleaseEnterTa3: 'Please enter TAPD query',
  pleaseEnterYourQuestion: 'Please enter question title to query',
  aiHasHelpedYou: 'AI has found recommended questions for you~',
  tapdPrecision: 'TAPD Precision Query',
  questionTitleCheck: 'Question Title Query',
  filterMethod: 'Filter Method',
  clickToUseA: 'Click to use AI to intelligently generate question title～',
  generating: 'Generating...',
  aiHasHelpedYou2:
    'AI has generated a title for you, click to generate again～',
  userFeedbackQuestion: 'User Feedback Issue Follow-up: {val1}{val2}',
  invalidFeedback: 'Invalid Feedback',
  theProductIsNotUserFriendly: 'Product is not user-friendly',
  usersDoNotKnowHowToUse: "Users don't know how to use",
  functionNotAvailable: 'Function not available',
  safetyRisk: 'Safety Risk',
  abnormalSituation: 'Abnormal Situation',
  normalAnswer: 'Normal Answer',
  manualIntervention: 'Manual Intervention',
  problemNotMatching: 'Problem Not Matched',
  tooManyRounds: 'Too Many Rounds',
  intentionNotRecognized: 'Intention Not Recognized',
  leisureDialogue: 'Casual Conversation',
  customIntent: 'Custom Intent',
  theAboveIsAi: 'The above are AI customer service session messages',
  satisfaction: 'AI Service Satisfaction',
  aiSessionCancellation: 'AI Session Message Count',
  theUserIsAlreadyInC: 'User has deleted this feedback on the client side',
  replyFailedM: 'Reply failed: {val1}',
  batchReplyPositive:
    'Batch reply is being processed, please wait for completion before trying again.',
  sentSatisfactory: 'Satisfaction rating sent',
  card: '] Card',
  usersFeelThatThereIs: 'Users feel helpful',
  usersFeelThatThereIsNothing: 'Users feel unhelpful',
  quickReply2: 'Quick Reply',
  statementSuccessfullyCompleted: 'Case closed successfully',
  clickToEndThis: 'Click to end this consultation service',
  replyAfterTheEnd:
    'After ending, reply status will be updated to "Manual service ended"',
  confirmedIssue2: 'Confirm the issue is resolved and end the session?',
  svgConversion: 'SVG conversion failed',
  ifThereIsNoOnc: 'If there is no oncall operational product,',
  synchronizeAfterModification:
    'After modification, synchronize and update issue title',
  tipsT3:
    '\n    {val1}<a href="{val2}" target="_blank" style="cursor: pointer;">{val3}</a><br/><br/>\n    【Issue Description】<br/>\n    <div style="padding-left: 20px;">\n      {val4}<br/>\n    </div>\n  ',
  divst4:
    '<div style="display: flex">Terminal Log: <div style="display: inline-block">{val1}</div></div>',
  ahref3: '<a href="{val1}" style="cursor: pointer;">Log Info {val2}</a><br/>',
  imgal:
    '<img alt="image.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  feedbackFromBr:
    '<br/>\n    【Feedback Content】<br/>\n    <div style="padding-left: 20px;">\n      {val1}\n      {val2}\n      {val3}\n      {val4}\n      {val5}\n      {val6}\n      {val7}\n    </div><br/>\n    【Feedback Screenshot】<br/>\n    <div style="padding-left: 20px;">\n      {val8}<br/><br/>\n    </div><br/>\n    【Feedback Video】<br/>\n    <div style="padding-left: 20px;">\n      {val9}<br/><br/>\n    </div><br/>\n    【Log Information】<br/>\n    <div style="padding-left: 20px;">\n      {val10}\n    </div><br/>\n    【Device Related】<br/>\n    <div style="padding-left: 20px;">\n      {val11}\n      {val12}\n      {val13}\n      {val14}\n      {val15}\n    </div><br/>\n    【Additional Information】<br/>\n    <div style="padding-left: 20px;">\n      {val16}\n    </div><br/>\n  ',
  imgal3:
    '<img alt="image.jpg" style="width: 180px; margin: 5px 10px 0 0" src="{val1}">',
  tipsT10:
    '{val1}[<a href="{val2}" target="_blank" style="cursor: pointer;">{val3}</a>]<br/><br/>\n    【Feedback Content】<br/>\n    <div style="padding-left: 20px;">\n      {val4}\n      {val5}\n      {val6}\n      {val7}\n      {val8}\n      {val9}\n      {val10}\n    </div><br/>\n    【Feedback Screenshot】<br/>\n    <div style="padding-left: 20px;">\n      {val11}<br/><br/>\n    </div><br/>\n    【Feedback Video】<br/>\n    <div style="padding-left: 20px;">\n      {val12}<br/><br/>\n    </div><br/>\n    【Log Information】<br/>\n    <div style="padding-left: 20px;">\n      {val13}\n      {val14}\n    </div><br/>\n    【Device Related】<br/>\n    <div style="padding-left: 20px;">\n      {val15}\n      {val16}\n      {val17}\n      {val18}\n      {val19}\n    </div><br/>\n    【Additional Information】<br/>\n    <div style="padding-left: 20px;">\n      {val20}\n    </div><br/>\n  ',
  applicationVersionFrom: 'Application Version Custom Filter',
  pleaseEnterTheVersion: 'Please enter version number',
  versionSearch: 'Version Search',
  selectedVersion: 'Selected Version (',
  pleaseEnterFilter: 'Please enter filter conditions to search',
  thereAreCurrentlyNoFilterNumbersAvailable: 'No filter data available',
  filter: 'Filter',
  versionFilteringRange: 'Version Filtering Range',
  basicSettings: 'Basic Settings',
  enterpriseWeChatRobot: 'Enterprise WeChat Robot',
  enterpriseWeChatAccount: 'Enterprise WeChat Account',
  deleteConditionGroup: 'Delete Condition Group',
  addCondition: 'Add Condition',
  addConditionGroup: 'Add Condition Group',
  addSiblingCondition: 'Add Sibling Condition',
  deleteThisCondition: 'Delete This Condition',
  pleaseSelectField: 'Please Select Field',
  pleaseSelectRelation: 'Please Select Relation',
  pleaseEnterValue: 'Please Enter Value',
  pleaseSelectTime: 'Please Select Time',
  loadingEllipsis: 'Loading…',
};
